{
  "version": 1,
  "asset_id": "7a84d475-168c-4f62-b216-24f96e7b6f14",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/7a84d475-168c-4f62-b216-24f96e7b6f14/hiatal-type-4-v3-800.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/7a84d475-168c-4f62-b216-24f96e7b6f14/hiatal-type-4-v3-800.webp",
  "original_filename": "hiatal-type-4-v3-800.webp",
  "size": 101682,
  "content_type": "image/webp",
  "created_at": "2026-10-28T23:04:02Z"
}
